import { apiEndpoint } from './env';
import { get, postNoAuth } from './communications';

class Auth {
  async login(email, password) {
    const body = {
      data: {
        type: 'auth',
        attributes: {
          email,
          password,
        },
      },
    };

    const authResult = await postNoAuth(`${apiEndpoint}/auth/userToken`, body);
    const { errors, newUser } = authResult;
    if (errors) {
      return (
        {
          valid: false,
          error: errors[0].detail,
        }
      );
    }
    this.setSession(authResult);
    return (
      {
        valid: true,
        newUser,
      }
    );
  }

  setSession(authResult) {
    const expiresAt = JSON.stringify((authResult.expires_in * 1000) + new Date().getTime());
    localStorage.setItem('access_token', authResult.access_token);
    localStorage.setItem('id_token', authResult.id_token);
    localStorage.setItem('expires_at', expiresAt);
  }

  resetPassword(email) {
    const body = {
      data: {
        type: 'auth',
        attributes: {
          email,
        },
      },
    };

    return postNoAuth(`${apiEndpoint}/auth/resetUserPassword`, body)
      .then(response => response)
      .catch(err => err);
  }

  // Check whether the current time is past the
  // Access Token's expiry time
  isAuthenticated() {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;
  }

  logout() {
    // Clear Access Token and ID Token from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
  }

  hasTokens() {
    return (
      localStorage.getItem('access_token')
      && localStorage.getItem('id_token')
      && localStorage.getItem('expires_at')
    );
  }

  isRouteAccessPermitted(authRequired) {
    return !this.hasTokens || (authRequired && !this.isAuthenticated());
  }

  getToken() {
    if (this.hasTokens) {
      return localStorage.getItem('access_token');
    }
    return false;
  }

  isJwtValid() {
    return get(`${apiEndpoint}/auth/validity`);
  }
}

export default new Auth();



// WEBPACK FOOTER //
// ./src/utils/auth.js